// extracted by mini-css-extract-plugin
var _1 = "BuildingTableRow-moduleBuildingTableRow__Z3_62 TableComponent-modulerow__xPAo4";
export { _1 as "BuildingTableRow" }
